import DPIncUtils from '../../../../includes/assets/js/modules/DPIncUtils';

export const loadBuilder = (mainCfg, instanceCreatorFce) => {
	if (mainCfg.dpDebugEn) console.log('builder config:', mainCfg);
	const currentUrl = new URL(window.location);
	const queryParamsDefs = mainCfg.queryParamsDefs;
	const tourId = DPIncUtils.getDpUrlParam('dp_qp_tour_id', queryParamsDefs, currentUrl);
	const createNew = DPIncUtils.getDpUrlParam('dp_qpb_create_new', queryParamsDefs, currentUrl);
	const builderMode = DPIncUtils.getDpUrlParam('dp_qpb_builder_mode', queryParamsDefs, currentUrl);
	if ((mainCfg.tours && mainCfg.tours.length) || builderMode === '3') {
		const mainCfgProcessed = { ...mainCfg };
		delete mainCfgProcessed.tours;
		mainCfgProcessed.builderOrigin = DPIncUtils.getDpUrlParam('dp_qpb_builder_origin', queryParamsDefs, currentUrl);
		mainCfgProcessed.builderMode = builderMode;
		mainCfgProcessed.originHashId = DPIncUtils.getDpUrlParam('dp_qpb_origin_el_id', queryParamsDefs, currentUrl);
		mainCfgProcessed.triggerId = DPIncUtils.getDpUrlParam('dp_qp_trigger_id', queryParamsDefs, currentUrl) || 0;
		mainCfgProcessed.initState = DPIncUtils.getDpUrlParam('dp_qpb_init_state', queryParamsDefs, currentUrl);
		mainCfgProcessed.inNewWindow = DPIncUtils.getDpUrlParam('dp_qpb_in_new_window', queryParamsDefs, currentUrl) === '1';
		mainCfgProcessed.mobileAltStepMode = DPIncUtils.getDpUrlParam('dp_qpb_mobile_alt_step_mode', queryParamsDefs, currentUrl);
		const delay = mainCfgProcessed.mobileAltStepMode === 'mobile_menu' ? 500 : 0;
		setTimeout(() => {
			if (builderMode === '3') {
				instanceCreatorFce(mainCfgProcessed, null);
			} else {
				mainCfg.tours.forEach((tourCfg) => {
					if ((createNew && tourCfg.createNew) || tourCfg.tourId == tourId) {
						instanceCreatorFce(mainCfgProcessed, tourCfg);
					}
				});
			}
		}, delay);
	}
};

export const $S = (selector, def = null) => {
	try {
		return $(selector);
	} catch (error) {
		return def;
	}
};

export const isTouchDevice = () => {
	try {
		return (('ontouchstart' in window)
			|| (navigator.maxTouchPoints > 0)
			|| (navigator.msMaxTouchPoints > 0));
	} catch (exception) {
		return false;
	}
};

export const i18n = (text, translations) => {
	if (translations[text]) return translations[text];
	return text;
};


